import { useContext, useEffect, useState } from "react";
import { Avatar, Badge, Drawer, Typography } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUser,
  faLifeRing,
  faRightFromBracket,
  faHandHoldingHeart,
  faListCheck,
  faUnlockKeyhole,
  faTableCells,
} from "@fortawesome/free-solid-svg-icons";
import { AuthContext } from "../useAuth";
import { config } from "../config";
import logo from "../images/carisity-logo.png";
import { faBell } from "@fortawesome/free-regular-svg-icons";
import { useUserNotifications } from "../api/Notifications";
import NotificationItem from "../components/NotificationItem";
import { isCaregiver, isOrgAdmin } from "../utils/userUtil";
import { useFeatureFlag } from "../api/FeatureFlags";
import { faHeart, faTable } from "@fortawesome/pro-solid-svg-icons";

export const useNavigation = (loginAction, withBrand) => {
  const { authenticated, logout, userId, user } = useContext(AuthContext);
  let { data: coursesEnabled } = useFeatureFlag("courses", `user:${userId}`);

  let userNav = useUserNavigation(
    authenticated,
    loginAction,
    logout,
    user,
    coursesEnabled?.enabled
  );
  const appNav = applicationNavigation(withBrand);

  return [...appNav, ...userNav];
};

const applicationNavigation = (withBrand) => {
  const nav = [];
  if (withBrand)
    nav.push({
      label: <img src={logo} />,
      key: "/",
      className: "logo",
    });
  nav.push({
    label: "Providers",
    key: "/caregivers",
  });
  // nav.push({
  //   label: "Classes",
  //   key: "/classes",
  // });
  return nav;
};

const useUserNavigation = (
  authenticated,
  loginAction,
  logout,
  user,
  coursesEnabled
) => {
  const { isEdifyAdmin } = useContext(AuthContext);
  return authenticated && user
    ? [
        {
          label: "My Sessions",
          key: "/sessions",
        },
        ...organizationNavigation(user),
        {
          label: <Notifications userId={user?.UserId} />,
          key: "notifications",
        },
        {
          label: (
            <Avatar
              shape="circle"
              src={user?.Avatar && `${config.imageUrl}/${user.Avatar}`}
              icon={<FontAwesomeIcon icon={faUser} />}
            />
          ),
          key: "User",
          children: [
            {
              label: "Dashboard",
              key: "/dashboard",
              icon: <FontAwesomeIcon icon={faTable} />,
            },
            {
              label: "Profile",
              key: "/profile",
              icon: <FontAwesomeIcon icon={faUser} />,
            },
            {
              label: "Favorites",
              key: "/favorites",
              icon: <FontAwesomeIcon icon={faHeart} />,
            },

            {
              type: "divider",
            },
            ...caregiverNavigation(user, coursesEnabled),
            ...adminNavigation(isEdifyAdmin),
            {
              label: "Support",
              key: "support",
              icon: <FontAwesomeIcon icon={faLifeRing} />,
            },
            {
              label: "Log out",
              key: "logout",
              icon: <FontAwesomeIcon icon={faRightFromBracket} />,
              onClick: () => {
                logout();
              },
            },
          ],
        },
      ]
    : [
        {
          label: "Log in / Sign up",
          key: "/login",
        },
      ];
};

// TODO: Add global actions for mark as read and delete

const Notifications = ({ userId }) => {
  const [notifications, setNotifications] = useState();
  const [unreadCount, setUnreadCount] = useState();
  const [showNotifications, setShowNotifications] = useState();

  const { data } = useUserNotifications(userId);

  useEffect(() => {
    if (data?.Notifications) {
      setNotifications(data.Notifications);
      setUnreadCount(data.Notifications.filter((x) => !x.Read).length);
    }
  }, [data]);

  return (
    <>
      <Badge
        // dot={notifications ? true : false}
        count={unreadCount}
        onClick={() => setShowNotifications(true)}
      >
        <Avatar
          icon={<FontAwesomeIcon icon={faBell} />}
          style={{ backgroundColor: "white", color: "black" }}
        />
      </Badge>
      <Drawer
        className="notification-drawer"
        title="Notifications"
        open={showNotifications}
        onClose={() => setShowNotifications(false)}
      >
        {!notifications ||
          (notifications.length === 0 && (
            <Typography.Text type="secondary">
              No new notifications
            </Typography.Text>
          ))}
        {notifications?.map((n) => (
          <NotificationItem
            key={n.NotificationId}
            notification={n}
            onClick={() => setShowNotifications(false)}
          />
        ))}
      </Drawer>
    </>
  );
};

const organizationNavigation = (user) => {
  return isOrgAdmin(user) && user.OrganizationId
    ? [
        {
          label: "My Organization",
          key: `/organizations/${user?.OrganizationId}`,
        },
      ]
    : [];
};

const caregiverNavigation = (user, coursesEnabled) => {
  const items = [];
  if (isCaregiver(user))
    items.push({
      label: "Caregiver Settings",
      key: "/profile/caregiver",
      icon: <FontAwesomeIcon icon={faHandHoldingHeart} />,
    });

  if (coursesEnabled) {
    items.push({
      label: "Manage Classes",
      key: "manageclasses",
      icon: <FontAwesomeIcon icon={faListCheck} />,
    });
  }
  if (items.length > 0) {
    items.push({ type: "divider" });
  }
  return items;
};

const adminNavigation = (isAdmin) => {
  return isAdmin
    ? [
        {
          label: "Administration",
          key: "/admin",
          icon: <FontAwesomeIcon icon={faUnlockKeyhole} />,
          children: [
            {
              label: "Usage",
              key: "/admin/usagereport",
            },
            { label: "Caregivers", key: "/admin/caregivers" },
          ],
        },
        { type: "divider" },
      ]
    : [];
};
